import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { openPositions } from '@/data/positions';
import NotFound from './NotFound';

const JobDetail = () => {
  const { id } = useParams<{ id: string }>();
  const job = openPositions.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  if (!job) {
    return <NotFound />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navigation />
      <section className="pt-24 pb-16 bg-background">
        <div className="container-custom max-w-3xl mx-auto">
          <Link to="/careers" className="text-primary underline mb-4 inline-block">&larr; Back to all openings</Link>
          <h1 className="text-4xl md:text-5xl font-bold mb-2">{job.title}</h1>
          {(job.location || job.contract) && (
            <div className="flex items-center space-x-4 text-muted-foreground mb-4">
              {job.location && <span>{job.location}</span>}
              {job.location && job.contract && <span>&bull;</span>}
              {job.contract && <span>{job.contract}</span>}
            </div>
          )}
          <p className="text-xl text-muted-foreground mb-8">{job.description}</p>

          <div className="prose prose-lg max-w-none mt-12">
            {job.introduction && (
              <>
                <h2 className="text-2xl font-semibold mb-4">{job.introduction.title}</h2>
                <p>{job.introduction.content}</p>
              </>
            )}
            <h2 className="text-2xl font-semibold mt-8 mb-4">Responsibilities</h2>
            <ul className="list-disc pl-5 space-y-1">
              {job.responsibilities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Qualifications</h2>
            <ul className="list-disc pl-5 space-y-1">
              {job.qualifications.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {job.hiringProcess && (
            <div className="mt-12">
              <h2 className="text-3xl font-semibold mb-8 text-center">{job.hiringProcess.title}</h2>
              <div className="max-w-2xl mx-auto space-y-8">
                {job.hiringProcess.steps.map((step, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex items-center justify-center w-12 h-12 bg-primary/10 text-primary rounded-full text-xl font-bold mr-6 shrink-0">{index + 1}</div>
                    <div>
                      <h3 className="text-xl font-semibold mb-1">{step.title}</h3>
                      <p className="text-muted-foreground">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="mt-12 text-center">
             <Button size="lg" asChild>
                {job.applyLink ? (
                  <a href={job.applyLink} target="_blank" rel="noopener noreferrer">Apply Now</a>
                ) : (
                  <a href={`mailto:martina@stratodata.eu?subject=Application for ${job.title}`}>Apply Now</a>
                )}
            </Button>
          </div>

        </div>
      </section>
      <Footer />
    </div>
  );
};

export default JobDetail; 